<template>
  <div>
    <v-tabs-items v-model="indiceAba">
      <v-tab-item>
        <v-card flat>
          <v-simple-table
            dense
            class="mt-3"
          >
            <thead v-if="0">
              <tr>
                <th
                  v-for="(key, index) in filteredKeys"
                  :key="`header-${key}-${index}`"
                >
                  {{ key | capitalize }}
                </th>
              </tr>
            </thead>
            <tbody class="linhas">
              <template v-for="(sequenciaGroup, canal) in dadosPaginados">
                <template v-for="(linhas, sequencia) in sequenciaGroup">
                  <tr :key="`canal-${canal}-sequencia-${sequencia}`">
                    <td
                      v-for="(value, key) in filterLinha(linhas[0])"
                      :key="`cell-${key}-${canal}-${sequencia}`"
                    >
                      <span>
                        <v-tooltip
                          v-if="key === 'valor' && value < 0"
                          bottom
                        >
                          <span>{{ $t('modulos.calibracao.valores.ponto_invalido') }}</span>
                        </v-tooltip>
                        {{ key === 'valor' ? (value | formatarNumeroComPrecisao) : value }}
                      </span>
                    </td>
                  </tr>
                  <tr
                    v-for="(linha, index) in linhas.slice(1)"
                    :key="`linha-${index}-${canal}-${sequencia}`"
                  >
                    <td
                      v-for="(value, key) in filterLinha(linha)"
                      :key="`cell-${key}-${canal}-${sequencia}-${index}`"
                    >
                      <span :class="{ 'red--text': key === 'valor' && value < 0 }">
                        <v-tooltip
                          v-if="key === 'valor' && value < 0"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="red"
                              v-bind="attrs"
                              v-on="on"
                            >
                              $alertCircleOutline
                            </v-icon>
                          </template>
                          <span>{{ $t('modulos.calibracao.valores.ponto_invalido') }}</span>
                        </v-tooltip>
                        {{ key === 'valor' ? (value | formatarNumeroComPrecisao) : value }}
                      </span>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </v-simple-table>
          <Paginator
            :rows="tamanhoPagina"
            :total-records="totalItens"
            :rows-per-page-options="[10, 20, 30]"
            class="p-paginator p-component fixed-bottom dropdown-paginacao-acima"
            @page="atualizarPagina"
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
  
  <script>
  import 'primevue/resources/themes/saga-blue/theme.css';
  import 'primevue/resources/primevue.min.css';
  import 'primeicons/primeicons.css';
  import Paginator from 'primevue/paginator';
  
  export default {
    components: {
      Paginator,
    },
    props: {
      ensaioInstrumentosPadroes: Array,
      ensaioFaixas: Array,
      ensaioCalibracao: Array,
      ensaioDados: Array
    },
    data() {
      return {
        abaAtiva: 0,
        indiceAba: 0,
        primeiraPagina: 0,
        tamanhoPagina: 10,
      };
    },
    computed: {
      filteredKeys() {
        return Object.keys(this.ensaioDados[0]).filter(key => key !== 'sequencia');
      },
      groupedEnsaioDados() {
        const grouped = this.ensaioDados.reduce((acc, item) => {
          if (!acc[item.canal]) {
            acc[item.canal] = {};
          }
          if (!acc[item.canal][item.sequencia]) {
            acc[item.canal][item.sequencia] = [];
          }
          acc[item.canal][item.sequencia].push(item);
          return acc;
        }, {});
  
        const orderedGrouped = {};
        Object.keys(grouped)
          .sort()
          .forEach(key => {
            orderedGrouped[key] = grouped[key];
          });
  
        return orderedGrouped;
      },
      dadosPaginados() {
        const dadosAgrupados = this.groupedEnsaioDados;
        const todosItens = Object.keys(dadosAgrupados).flatMap(canal =>
          Object.values(dadosAgrupados[canal]).flat()
        );
  
        const inicio = this.primeiraPagina;
        const fim = inicio + this.tamanhoPagina;
        const itensPagina = todosItens.slice(inicio, fim);
  
        const paginados = itensPagina.reduce((acc, item) => {
          if (!acc[item.canal]) {
            acc[item.canal] = {};
          }
          if (!acc[item.canal][item.sequencia]) {
            acc[item.canal][item.sequencia] = [];
          }
          acc[item.canal][item.sequencia].push(item);
          return acc;
        }, {});
  
        return paginados;
      },
      totalItens() {
        return Object.keys(this.groupedEnsaioDados).flatMap(canal =>
          Object.values(this.groupedEnsaioDados[canal]).flat()
        ).length;
      }
    },
    methods: {
      filterLinha(linha) {
        return Object.fromEntries(
          Object.entries(linha).filter(([key]) => key !== 'sequencia')
        );
      },
      salvarAoMudar(novoIndice) {
        this.$emit("aba-mudou", novoIndice);
      },
      atualizarPagina(event) {
        this.primeiraPagina = event.first;
        this.tamanhoPagina = event.rows;
      }
    }
  };
  </script>
  